import { AdCommonEvents, VERSION } from '../constants'

export const Pixel1EventsDict = {
  mania1: {
    [AdCommonEvents.Visit]: 1042108,
    [AdCommonEvents.RegNotFinished]: 1042112,
    [AdCommonEvents.RegFinished]: 1042113,
    [AdCommonEvents.LandingPageView]: null,
  },
  mania2: {
    [AdCommonEvents.Visit]: 1041903,
    [AdCommonEvents.RegNotFinished]: 1041906,
    [AdCommonEvents.RegFinished]: 1041907,
    [AdCommonEvents.LandingPageView]: null,
  },
} as const satisfies Record<VERSION, Record<AdCommonEvents, number | null>>

interface fetchADSProps {
  eventNumber: number
  userId?: number
  callback?: () => void
}

export const fetchADS = ({ eventNumber, userId, callback }: fetchADSProps) => {
  fetch(`https://r.uuidksinc.net/match/${eventNumber}${userId ? `/?remote_uid=${userId}` : ''}`)
    .then(() => callback?.())
    .catch(() => null)
}
